var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[(!_vm.$route.meta.hideNavigation)?_c('appbar',{staticClass:"d-print-none"}):_vm._e(),_c('transition',{attrs:{"name":"router-anim"}},[(!_vm.$route.meta.hideNavigation)?_c('v-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.path})],1):_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }